<div class="chat-active-entity-container container"
     *ngIf="activeFeature?.activeEntityRequired">
  <div class="chat-info-container">
    <button nz-button
            nzType="default"
            nzShape="round"
            class="info-button"
            (click)="onInfoButtonClicked()">
      <i class="fa-solid fa-info"></i>
    </button>
    <div class="info-text"
         *ngIf="activeEntityItem && entityCardListConfig">
      <span>You are currently working on {{ activeEntityItem && entityCardListConfig?.titleFieldName ?
        activeEntityItem[entityCardListConfig?.titleFieldName] : activeEntityItem?.title ||
        activeEntityItem?.name|| activeEntityItem?.id
        }}</span>
    </div>
    <div class="info-text"
         *ngIf="!activeEntityItem">
      <span>There is no selected entity, Please select an entity to execute actions</span>
    </div>
  </div>
  <div>
    <button nz-button
            nzType="default"
            class="change-entity-button"
            (click)="onChangeEntityButtonClicked()">
      <i class="fa-solid fa-repeat"></i>
    </button>
  </div>
</div>

<!--
<div *ngIf="isAiInProgress"
     class="ai-progress-container container">
  <button nz-button
          nzType="default"
          nzShape="round"
          class="info-button">
    <i class="fa-solid fa-circle-notch fa-spin"></i>
  </button>
  <div class="info-text">
    <span>Rapider AI is processing your request. Please wait...</span>
  </div>
</div>
-->


<div class="chat-input-container container">
  <!-- Hidden File Input -->
  <input #fileInput
         type="file"
         multiple
         accept=".csv,.txt,.json,.png,.jpg,.jpeg,.pdf,.doc,.docx,.xls,.xlsx,.md,.xml"
         (change)="onFileSelected($event)"
         style="display: none;"
         #fileInputRef>

  <!-- File List Section -->
  <div *ngIf="uploadedFiles.length > 0" class="file-list-section">
    <div class="file-list-header">
      <span class="file-count">{{ uploadedFiles.length }} file(s) selected</span>
    </div>
    <div class="file-list-content">
      <div *ngFor="let file of uploadedFiles; let i = index" class="file-item">
        <div class="file-item-content">
          <div class="file-icon">
            <img *ngIf="isImageFile(file) && getFilePreviewUrl(file)"
                 [src]="getFilePreviewUrl(file)"
                 [alt]="file.name"
                 class="file-thumbnail">
            <i *ngIf="!isImageFile(file) || !getFilePreviewUrl(file)"
               nz-icon
               [nzType]="getFileIcon(file.name)"></i>
          </div>
          <div class="file-info"
               (click)="handleFileClick(file)">
            <div class="file-name" [title]="file.name">{{ file.name }}</div>
            <div class="file-size">{{ formatFileSize(file.size) }}</div>
          </div>
          <div class="file-actions">
            <rappider-button [disabled]="!!isAiInProgress"
                             [size]="ButtonSize.Small"
                             [type]="ButtonType.Default"
                             [icon]="{ name: 'fa-solid fa-eye' }"
                             (click)="handlePreview(file); $event.stopPropagation()"
                             class="preview-button">
            </rappider-button>

            <rappider-button [disabled]="!!isAiInProgress"
                             [size]="ButtonSize.Small"
                             [type]="ButtonType.Default"
                             [icon]="{ name: 'fa-solid fa-trash' }"
                             (click)="handleRemoveFile(i); $event.stopPropagation()"
                             class="remove-button">
            </rappider-button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <textarea #textArea
            nz-input
            [(ngModel)]="message"
            placeholder="Message Rapider AI..."
            class="chat-textarea"
            [nzAutosize]="{ minRows: 1, maxRows: 6 }"
            (keypress)="onKeyPress($event)"></textarea>

  <div class="chat-actions">
    <!-- Left Actions -->
    <div class="chat-left-actions">

      <!-- File Upload Button -->
      <button nz-button
              nz-tooltip
              nzTooltipTitle="Upload Files"
              nzType="default"
              nzShape="round"
              class="file-upload-button"
              (click)="onFileUploadButtonClicked()">
        <i class="fa-solid fa-paperclip"></i>
      </button>

      <!-- <nz-button-group> -->
      <div *ngIf="buttonSelectionWrapper" class="button-selection-wrapper">
        <ng-container>
          <button nz-button
                  nzType="default"
                  nzShape="round"
                  [ngStyle]="{'background-color': 'color-mix(in srgb, var(--primary-color) 5%, transparent)','border-color': 'var(--primary-color)'}"
                  class="feature-button"
                  [ngClass]="{'primary-feature-button': activeFeature?.name === primaryFeature?.name}"
                  (click)="onFeatureSelected(activeFeature)">
            <i class="fa-regular fa-sparkles"></i>
              {{activeFeature?.title}}
              <button *ngIf="activeFeature?.name === primaryFeature?.name"
                    nz-button
                    nzType="default"
                    nzShape="round"
                    [ngStyle]="{'background-color': 'transparent','border-color': 'color-mix(in srgb, var(--secondary-button-text-color) 50%, transparent)'}"
                    class="feature-button primary-feature-settings"
                    (click)="onDataSourceSelectModalOpen()">
              <i class="fa-regular fa-gear primary-feature-settings-icon"></i>
            </button>
          </button>
        </ng-container>

        <ng-container *ngIf="(visibleFeatures?.length ?? 0) > 0">
          <button [joyrideStep]="joyrideStepTwo?.joyrideStep || ''"
                  [title]="joyrideStepTwo?.title"
                  [text]="joyrideStepTwo?.text"
                  (next)="onNextClick(joyrideStepTwo?.joyrideStep)"
                  (done)="onJoyrideDoneButtonClick()"
                  nz-button
                  nz-tooltip
                  nz-dropdown
                  [nzTooltipTitle]="'Change AI Agent / Tool'"
                  [nzVisible]="displayAIFeaturesDropdown"
                  nzTrigger="click"
                  [nzDropdownMenu]="menu1"
                  class="change-feature-button margin-left"
                  nzPlacement="topLeft"
                  (nzVisibleChange)="displayAIFeaturesDropdown = $event">
            <i class="fa-regular fa-ellipsis"></i>
          </button>

          <nz-dropdown-menu #menu1="nzDropdownMenu">
            <ul nz-menu>
              <ng-container *ngFor="let feature of visibleFeatures">
                <li nz-menu-item
                    (click)="onFeatureSelected(feature)">
                  <i class="{{feature.icon.name}} feature-icon"></i>
                  {{ feature.title }}
                </li>
              </ng-container>
            </ul>
          </nz-dropdown-menu>

        </ng-container>

        <rappider-modal [(visible)]="dataSourceModalVisibility"
                        [title]="'Data Sources'"
                        [width]="'80%'"
                        [okText]="dropdownColumns?.length ? 'Save' : null"
                        [cancelText]="dropdownColumns?.length ? 'Cancel' : 'Close'"
                        [closeIconVisibility]="true"
                        (cancelClick)="dataSourceModalCancelClick()"
                        (okClick)="dataSourceModalOkClick()">
          <rappider-alert *ngIf="!dropdownColumns?.length"
                          [type]="'info'"
                          [title]="'No Completed Data Sources Available'"
                          [description]="'No Data Sources have been successfully completed yet. Please check your progress and try again.'"
                          [showIcon]="true"></rappider-alert>
          <div *ngIf="dropdownColumns?.length"
                class="info-grid-wrapper">
            <rappider-alert [type]="'info'"
                            [title]="'Select the Data Sources You Want to Include in the Search'"
                            [description]="'Data Sources with a completed status can be selected. To select the remaining data sources, please wait until their status is completed.'"
                            [showIcon]="true"></rappider-alert>
            <rappider-list-grid [config]="listGridConfig"
                                [data]="dropdownColumns"
                                [searchButtonActive]="true"
                                [enableRowPointer]="listGridConfig?.enableRowPointer"
                                (selectionChange)="onSelectionChange($event)"></rappider-list-grid>
          </div>
        </rappider-modal>
      </div>
      <!-- <nz-select *ngIf="activeFeature?.name === 'RAGSearch'"
                 [(ngModel)]="visibleColumns"
                 class="filter-columns-select"
                 [nzShowSearch]="false"
                 [nzShowArrow]="true"
                 [nzMode]="'multiple'"
                 [nzMaxTagCount]="0"
                 [nzMaxTagPlaceholder]="colSelectPlaceHolder"
                 (ngModelChange)="onDropdownColumnChange()">
        <nz-option *ngFor="let column of dropdownColumns"
                   [nzLabel]="column.title"
                   [nzValue]="column.name"></nz-option>
      </nz-select> -->
      <!-- <ng-template #colSelectPlaceHolder
                    let-selectedList>
        <div class="filter-columns-placeholder">
          <div><i class="fa-kit fa-regular-database-circle-bolt"></i></div>
          <div>&nbsp;Datasources</div>
        </div>
      </ng-template> -->

      <!-- Help button with question mark icon -->
      <!-- TODO: Implement -->
      <!-- <button nz-button
              nzType="default"
              nzShape="round"
              class="help-button"
              (click)="onHelpButtonClicked()">
        <i class="fas fa-question"></i>
      </button> -->
    </div>

    <!-- Right Actions -->
    <div class="chat-right-actions">
      <!-- <button nz-button
              nzType="default"
              nzShape="round">
        <i class="fas fa-microphone"></i>
      </button>
      <button nz-button
              nzType="default"
              nzShape="round">
        <i class="fas fa-paperclip"></i>
      </button> -->
      <!-- Data Sources -->
      <!-- <ng-container *ngIf="displayDataSourceButton">
        <button nz-button
                nz-tooltip
                [nzTooltipTitle]="'Display/Hide data sources side panel'"
                nzType="default"
                nzShape="round"
                (click)="onDataSourcesButtonClicked()">
          <i class="fa-regular fa-database"></i>
        </button>
      </ng-container> -->

      <ng-container *ngIf="displayMessageNavigationButtons">
        <button nz-button
                nz-tooltip
                [disabled]="!previousMessage || isAiInProgress"
                [nzTooltipTitle]="previousMessage?.message || 'Previous Message'"
                nzTooltipPlacement="top"
                type="default"
                (click)="onGoToPreviousMessages(currentUserMessage?.id || '')"
                class="previous-page-button">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button nz-button
                nz-tooltip
                [disabled]="!nextMessage"
                [nzTooltipTitle]="nextMessage?.message || 'Next Message'"
                nzTooltipPlacement="top"
                type="default"
                (click)="onGoToNextMessages(currentUserMessage?.id || '')"
                class="next-page-button">
          <i class="fas fa-chevron-right"></i>
        </button>

      </ng-container>

      <button nz-button
              nz-tooltip
              [nzTooltipTitle]="'Send Message'"
              nzType="default"
              nzShape="round"
              class="send-button"
              [disabled]="isAiInProgress || (!message.trim() && uploadedFiles.length === 0)"
              (click)="onSendMessage()">
        <i class="fas fa-arrow-up"></i>
      </button>
    </div>
  </div>
</div>

<!-- Preview Modal -->
<nz-modal [nzVisible]="showPreviewModal"
          [nzContent]="previewModalContent"
          nzCentered
          nzWidth="80%"
          [nzFooter]="null"
          (nzOnCancel)="closePreviewModal()">
  <ng-template #previewModalContent>
    <img [src]="previewImage"
         style="width: 100%" />
  </ng-template>
</nz-modal>
